import { render, staticRenderFns } from "./MyDayCRM.vue?vue&type=template&id=042e4e15&scoped=true"
import script from "./MyDayCRM.vue?vue&type=script&lang=js"
export * from "./MyDayCRM.vue?vue&type=script&lang=js"
import style0 from "./MyDayCRM.vue?vue&type=style&index=0&id=042e4e15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042e4e15",
  null
  
)

export default component.exports